/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CRSFSecReviewSourcelistsData
 */
export interface CRSFSecReviewSourcelistsData {
    /**
     * 
     * @type {boolean}
     * @memberof CRSFSecReviewSourcelistsData
     */
    ecrime: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CRSFSecReviewSourcelistsData
     */
    log4j: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CRSFSecReviewSourcelistsData
     */
    other: boolean;
}

/**
 * Check if a given object implements the CRSFSecReviewSourcelistsData interface.
 */
export function instanceOfCRSFSecReviewSourcelistsData(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "ecrime" in value;
    isInstance = isInstance && "log4j" in value;
    isInstance = isInstance && "other" in value;

    return isInstance;
}

export function CRSFSecReviewSourcelistsDataFromJSON(json: any): CRSFSecReviewSourcelistsData {
    return CRSFSecReviewSourcelistsDataFromJSONTyped(json, false);
}

export function CRSFSecReviewSourcelistsDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFSecReviewSourcelistsData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'ecrime': json['ecrime'],
        'log4j': json['log4j'],
        'other': json['other'],
    };
}

export function CRSFSecReviewSourcelistsDataToJSON(value?: CRSFSecReviewSourcelistsData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ecrime': value.ecrime,
        'log4j': value.log4j,
        'other': value.other,
    };
}

